import React from "react";
import './s2.scss';

const data = [
  {
    title: "Aprobación Rápida y Desembolso Instantáneo",
    desc: "Solicitud 100% en línea con evaluación automática. Recibe tu dinero en minutos, ideal para necesidades urgentes.",
    icon: "launch"
  },
  {
    title: "Montos Flexibles y Préstamos Personalizados",
    desc: "Ofrecemos diferentes opciones de préstamo para adaptarnos a tus necesidades financieras.",
    icon: "pencil"
  },
  {
    title: "Intereses Bajos y Total Transparencia",
    desc: "in costos ocultos ni comisiones sorpresa. Te garantizamos condiciones claras y justas.",
    icon: "download"
  }
]


const S2 = () => {
  return (
    <div className="gogo-s-2">
      <div className="data-wrapper">
        {
          data.map(item => (
            <div className="card" key={item.icon}>
              <div className={`icon ${item.icon}`}></div>
              <div>
                <p className="title">{item.title}</p>
                <p className="desc">{item.desc}</p>
              </div>
            </div>
          ))
        }
      </div>
      <div className="people-2 absolute"></div>
      <div className="phone-2 absolute"></div>
      <div className="spark-2 absolute"></div>
      <div className="dollar-3 absolute"></div>
      <div className="dollar-4 absolute"></div>
    </div>
  )
}

export default S2;
